import Logger from "@cappelendamm/logger";
import { selectUpdateCustomerInput } from "../selectors/selecUpdateCustomerInput.js";
import { UpdateCustomer } from "../mutations/UpdateCustomer.core.js";
export async function updateCustomer(customerInput, customerId, { client }) {
    Logger.log(`Updating customer with customerId: ${customerId}...`);
    const updateSanitized = selectUpdateCustomerInput(customerInput);
    const result = await client.core.request(UpdateCustomer, {
        identifier: customerId,
        input: updateSanitized,
    });
    if (result.updateCustomer.__typename !== "Customer") {
        throw new Error(`Error updating customer with identifier: ${customerId}. ErrorName: ${result.updateCustomer.errorName}. Message: ${result.updateCustomer.message}`);
    }
    Logger.log("Complete updating customer:  ", result);
    return result.updateCustomer.identifier;
}
